import { FC } from 'react';

interface Props {
    label: string;
    className?: string;
}

const FormItem: FC<Props> = ({ label, className, children }) => {
    return (
        <div className={`flex flex-col h-fit w-fit gap-2 ${className}`}>
            <div className="text-13 font-medium font-sf text-sf-gray-800">{label}</div>
            <div>{children}</div>
        </div>
    );
};

export default FormItem;
